import { snakeCase } from "lodash";

/**
 * Recursively converts all keys in an object (and nested objects) to snake_case
 */
export function toSnakeCase(obj: unknown): unknown {
  if (obj === null || obj === undefined) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(toSnakeCase);
  } else if (obj !== null && typeof obj === "object" && obj.constructor === Object) {
    return Object.entries(obj).reduce(
      (acc, [key, value]) => {
        acc[snakeCase(key)] = toSnakeCase(value);
        return acc;
      },
      {} as Record<string, unknown>
    );
  }
  return obj;
}
